import axios from "services/api";;
import ActionButton from 'components/common/ActionButton';
import FalconCardHeader from 'components/common/FalconCardHeader';
import IconButton from 'components/common/IconButton';
import { API3_HOST } from 'helpers/urlHelper';
import React, { useEffect, useState } from 'react';
import { Card, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import CreateModal from '../CreateModal';

/***
 * Page showing all the queries available to the user.
 */
export default function QueryList() {
  const navigate = useNavigate();
  const [createModalShow, setCreateModalShow] = React.useState(false);
  const [myQueries, setMyQueries] = useState([]);

  const deleteQuery = id => {

    axios({
      method: 'delete',
      url: `${API3_HOST}/dashboard/query/${id}`
    })
      .then(() => {
        // console.log('deleted query');
        loadData();
      })
      .catch(err => {
        console.log('did not load data');
        console.error('Failed to load layout', err);
      });
  };

  const loadData = () => {
    // console.log('loading data');
    axios({
      method: 'get',
      url: `${API3_HOST}/dashboard/query`
    })
      .then(result => {
        // console.log('loaded data');
        setMyQueries(result.data);
      })
      .catch(err => {
        console.log('did not load data');
        console.error('Failed to load layout', err);
      });
  };
  useEffect(() => {
    // load widget data from endpoint
    loadData();
  }, []);

  return (
    <>
      <CreateModal
        title="Create New Query"
        endpoint="/dashboard/query/create"
        redirect="/dashboard/query/"
        show={createModalShow}
      ></CreateModal>

      <Card className="p-0">
        <FalconCardHeader
          title="Queries"
          light
          titleTag="h4"
          endEl={
            <IconButton
              size="sm"
              variant="falcon-primary"
              iconClassName="me-2"
              icon="plus"
              onClick={() => {
                setCreateModalShow(true);
              }}
            >
              Create New Query
            </IconButton>
          }
        />

        <Card.Body className="p-0">
          {myQueries.length == 0 ? (
            <div className="text-center">No queries to show.</div>
          ) : (
            <Table responsive size="sm" bordered>
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">SQL</th>
                  <th className="text-end" scope="col">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {myQueries.map((query, index) => (
                  <tr key={index}>
                    <td>{query.name}</td>
                    <td>{query.sql}</td>
                    <td className="text-end">
                      <ActionButton
                        icon="edit"
                        title="Edit"
                        variant="action"
                        className="p-0 me-2"
                        onClick={() => {
                          navigate(`/dashboard/query/${query.id}`);
                        }}
                      />
                      <ActionButton
                        icon="trash-alt"
                        title="Delete"
                        variant="action"
                        className="p-0"
                        onClick={() => {
                          if (
                            confirm(
                              'Are you sure you wish to delete this query?'
                            )
                          ) {
                            deleteQuery(query.id);
                          }
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </>
  );
}
